module.exports = __webpack_public_path__ + "images/84489b5aabb6febaf00444c4e11e8954-logo_sponsors.png";